import { render, staticRenderFns } from "./StudentFormModal.vue?vue&type=template&id=2cae3442&scoped=true"
import script from "./StudentFormModal.vue?vue&type=script&lang=js"
export * from "./StudentFormModal.vue?vue&type=script&lang=js"
import style0 from "./StudentFormModal.vue?vue&type=style&index=0&id=2cae3442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cae3442",
  null
  
)

export default component.exports